import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import LoadingOverlay from "../../../shared/components/LoadingOverlay";
import AddActionButton from "../common/AddActionButton";
import EditActionButton from "../common/EditActionButton";
import Modal from "../../../shared/ui/Modal";
import testTemplateActionCreators from "../../store/test-templates/action-creators";
import './TestTemplates.scss';
import './TestTemplateDetails.scss';
import {Alert} from "reactstrap";
import {withRouter} from "react-router-dom";
import QuestionEdit from "./QuestionEdit";
import QuestionList from "./QuestionList";
import CustomForm from "../../../shared/components/form/CustomForm";
import DisplayBoolean from "../../../shared/forms/DisplayBoolean";
import {createTestTemplateConfig} from "../../../shared/components/form/TestTemplatesConfig";

function mapStateToProps(state) {
  return {
    testTemplates: state.testTemplates.list,
    testTemplatesMap: state.testTemplates.map,
    userContext: state.common.userContext
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTestTemplates() {
      return dispatch(testTemplateActionCreators.fetchTestTemplates());
    },
    updateTestTemplate(form) {
      return dispatch(testTemplateActionCreators.updateTestTemplates(form));
    }
  };
}

class TestTemplateDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isAddingQuestion: false,
      isEditingQuestion: null,
      isLoadingCreate: false,
      isUpdatingTestTemplate: false,
      isEditingTestOptions: false,
    }
  }

  get testTemplate() {
    let testTemplate = this.props.testTemplatesMap[this.state.selectedGuid];
    if (testTemplate) {
      testTemplate.attempts = testTemplate.attempts ? testTemplate.attempts.toString() : null;
      testTemplate.duration = testTemplate.duration ? testTemplate.duration.toString() : null;
      testTemplate.passing_score = testTemplate.passing_score ? testTemplate.passing_score.toString() : null;
      testTemplate.questions_displayed = testTemplate.questions_displayed ? testTemplate.questions_displayed.toString() : null;
      testTemplate.objective = testTemplate.settings ? testTemplate.settings.objective : 0;
      testTemplate.subjective = testTemplate.settings ? testTemplate.settings.subjective : 0;
      testTemplate.shuffle_questions = !testTemplate.settings || testTemplate.settings.shuffle_questions !== false;
    }

    return testTemplate;
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
      selectedGuid: this.props.match.params.guid
    });

    this.props.fetchTestTemplates()
      .then(() => {
        this.setState({
          isLoading: false
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false
        });
      })
  }

  openCreateTestTemplate() {
    this.setState({
      isAddingQuestion: true
    })
  }

  openEditTestOption() {
    this.setState({
      isEditingTestOptions: true
    })
  }

  openTestReports(testTemplate) {
    this.props.history.push(`/test-template-reports/${testTemplate.id}`);
  }

  closeTestTemplate() {
    this.setState({
      isAddingQuestion: false
    })
  }

  closeEditQuestion() {
    this.setState({
      isEditingQuestion: false
    })
  }

  closeEditTestOption() {
    this.setState({
      isEditingTestOptions: false
    })
  }

  onEditQuestion(question) {
    this.setState({
      isEditingQuestion: {...question}
    })
  }

  addQuestion(question) {
    this.setState({
      isAddingQuestion: true
    })
    this.props.updateTestTemplate({
      ...this.testTemplate,
      questions: [
        ...(this.testTemplate.questions || []),
        question
      ]
    })
      .then(() => {
        this.setState({
          isAddingQuestion: false
        })
      })
      .catch(() => {

      })
  }

  editQuestion(question) {
    this.props.updateTestTemplate({
      ...this.testTemplate,
      questions: this.testTemplate.questions.map(q => q.id === question.id ? question : q)
    })
      .then(() => {
        this.setState({
          isEditingQuestion: null
        })
      })
      .catch(() => {

      })
  }

  deleteQuestion(question) {
    this.props.updateTestTemplate({
      ...this.testTemplate,
      questions: this.testTemplate.questions.filter(q => q.id !== question.id)
    })
      .then(() => {
        this.setState({
          isEditingQuestion: null
        })
      })
      .catch(() => {

      })
  }

  saveTestTemplate(form) {
    this.setState({
      isUpdatingTestTemplate: true
    })
    this.props.updateTestTemplate({
      ...this.testTemplate,
      ...form
    })
      .then(() => {
        this.setState({
          isUpdatingTestTemplate: false,
          isEditingTestOptions: false
        })
      })
      .catch(() => {
        this.setState({
          isUpdatingTestTemplate: false,
          isEditingTestOptions: false
        })
      })
  }

  render() {
    return (
      <LoadingOverlay isLoading={!this.testTemplate}>
        <div className="app-content-header test-template-header">
          <h4 className="title">{this.testTemplate ? this.testTemplate.title : ''}</h4>
          {!this.props.userContext.hasScope(['fto']) &&
            <AddActionButton label={'question'} onAdd={() => this.openCreateTestTemplate()}/>
          }
        </div>
        <div className="test-templates app-content">
          <div className="test-templates-card">
            {this.testTemplate &&
              <Fragment>
                <div className="test-template-details">
                  <div>Passing percentage {this.testTemplate.passing_score}</div>
                  <div>Questions displayed {this.testTemplate.questions_displayed}</div>
                </div>

                <div className="test-template-details">
                  <DisplayBoolean
                    label="Shuffle questions"
                    value={this.testTemplate.shuffle_questions}
                  />
                </div>

                <div className="test-template-details">
                  <div>Mode {this.testTemplate.mode}</div>
                  <div>Attempts {this.testTemplate.attempts}</div>
                </div>

                <div className="test-template-details">
                  <div>Duration (minutes) {this.testTemplate.duration}</div>
                  <div>
                    <DisplayBoolean
                      label="Allow taker to view the results"
                      value={this.testTemplate.allowTakerViewResults}
                    />
                  </div>
                </div>

                <div className="test-template-details">
                  <div>
                    <DisplayBoolean
                      label="Allow taker to view the correct answers"
                      value={this.testTemplate.allowTakerViewCorrectAnswer}
                    />
                  </div>
                  <div>
                    <DisplayBoolean
                      label="Allow taker to change the answer"
                      value={this.testTemplate.allowTakerChangeAnswerIfCorrectDisplayed}
                    />
                  </div>
                </div>

                <div className="test-template-details">
                  <div>
                    <DisplayBoolean
                      label="Show the correct answer if wrong is selected"
                      value={this.testTemplate.showCorrectAnswerIfWrongSelected}
                    />
                  </div>
                </div>

                <div className="test-template-details">
                  <div>
                    <div>No. Subjective questions {this.testTemplate.subjective}</div>
                  </div>
                </div>

                <div className="test-template-details">
                  <div>
                    <div>No. Objective questions {this.testTemplate.objective}</div>
                  </div>
                </div>

                <div className="test-template-details btns-container">
                  {!this.props.userContext.hasScope(['fto']) &&
                  <EditActionButton label={'Test Details'} onEdit={() => this.openEditTestOption()}/>
                  }

                  <Modal
                    title="Edit Test Options"
                    isOpen={this.state.isEditingTestOptions}
                    onClose={() => this.closeEditTestOption()}
                  >
                    {this.testTemplate &&
                    <CustomForm config={createTestTemplateConfig} isLoading={this.state.isUpdatingTestTemplate}
                                initialValues={this.testTemplate} saveLabel="Save" saveSmall={true}
                                onSubmit={form => this.saveTestTemplate(form)}/>
                    }
                  </Modal>

                  <div>
                    <button className="button small primary" onClick={() => this.openTestReports(this.testTemplate)}>
                      Test Reports
                    </button>
                  </div>
                </div>
              </Fragment>
            }

            {this.testTemplate && !this.testTemplate.questions && <Alert color="primary">No questions added</Alert>}
            {this.testTemplate && this.testTemplate.questions && (
              <Fragment>
                <QuestionList
                  questions={this.testTemplate.questions}
                  testTemplate={this.testTemplate}
                  canEdit={true}
                  onEdit={(question) => this.onEditQuestion(question)}
                  onDelete={(question) => this.deleteQuestion(question)}
                  passingScore={this.testTemplate.passing_score}
                />
              </Fragment>
            )}
          </div>
        </div>

        <Modal
          title="Create question"
          isOpen={this.state.isAddingQuestion}
          onClose={() => this.closeTestTemplate()}
        >
          {this.state.isAddingQuestion && (
            <QuestionEdit testTemplateId={this.testTemplate.id} addQuestion={(question) => this.addQuestion(question)}/>
          )}
        </Modal>
        <Modal
          title="Edit question"
          isOpen={!!this.state.isEditingQuestion}
          onClose={() => this.closeEditQuestion()}
        >
          {this.state.isEditingQuestion && (
            <QuestionEdit initialValues={this.state.isEditingQuestion}
                          testTemplateId={this.testTemplate.id}
                          addQuestion={(question) => this.editQuestion(question)}/>
          )}
        </Modal>
      </LoadingOverlay>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TestTemplateDetails));
